module.exports = __webpack_public_path__ + "media/images/btn_statistics-681a40585164dd26d1362b046e0f4049.png";